import Component from 'components/pages/ResetPasswordRequest/ResetPasswordRequest';
import { buildPage } from 'utils/pageHelper';
import { DASHBOARD } from 'components/pages//pages';

export default buildPage(Component, {
  fullPage: true,
  loggedInRedirect: DASHBOARD.path,
  metaData: {
    title: 'Reset Password',
    description: 'Request a password reset',
  },
  unlisted: true,
});
